import { PropsWithChildren } from 'react';

export const GREEN = '#45be26';
export const YELOW_GREEN = '#BEB226';
export const ORANGE = 'orange';
export const RED = 'red';

export const getProgressColor = (progress: number) => {
  if (progress >= 75) {
    return RED;
  } else if (progress > 50) {
    return ORANGE;
  } else if (progress > 25) {
    return YELOW_GREEN;
  } else {
    return GREEN;
  }
};

export type TimerPropType = PropsWithChildren & {
  start: number;
  current: number;
  target: number;
  isStartProgress: boolean;
  size: number;
  /**
   * EN-10420: render the countdown VISUAL only — no warning beeps, no
   * vibration, no timeout sound. The one true SeatTimer on the seat keeps
   * owning every audio/haptic cue; extra on-screen instances (the bet tray's
   * countdown) must set this or the player hears doubled cues each turn.
   */
  presentationOnly?: boolean;
  /**
   * EN-10920: this timer is the local player's own decision clock — their
   * betting turn, or their open multi-run vote — so it plays the per-second
   * warning beeps. The seat knows this and the timer cannot: during a vote the
   * seat being asked is not `game.move`. Left undefined, the timer falls back to
   * "the betting turn is the local player's", which is all a betting turn needs.
   */
  ownsWarningCue?: boolean;
};
